// TODO: this should be refactored sooner than later
(function() {
    'use strict';

    angular
        .module('virtualFairs')
        .controller('VirtualFairRegistrationController', VirtualFairRegistrationController);

    /* @ngInject */
    function VirtualFairRegistrationController($q, $filter, $scope, $state, $stateParams, $http, API_BASE, $uibModal, currencyFormatFilter, toastr, expos, VirtualFairService) {
        let vm = this;
        
        vm.query = [];
        vm.registeredFairs  = [];
        vm.preRegistrations = [];
        vm.registrations = [];
        vm.boothNamePositionExpo = {};
        //shared
        vm.boothNameList = [];
        vm.contactNameList = [];
        vm.contactEmailList = [];
        vm.pavilionList  = [];
        vm.today = moment().format("YYYY-MM-DD");
        vm.contact_name  = [];
        vm.contact_email = [];
        vm.hideSeeAllBtn = false;
        vm.saving = false;
        vm.hasPavilion = false;
        

        vm.expos = expos;
        vm.getPreRegistrations = getPreRegistrations;
        vm.getRegisters        = getRegisters;
        vm.seeAllEvents = seeAllEvents;
        vm.toogle = toogle;
        vm.prepareData = prepareData;
        vm.save = save;
        vm.clearFields = clearFields;
        vm.extractFasciaName = extractFasciaName;
        vm.extractPavilionName = extractPavilionName;
        vm.extractContactName = extractContactName;
        vm.checkPreRegisterVsRegister = checkPreRegisterVsRegister;
        vm.extractContactEmail = extractContactEmail;
        vm.refreshResults = refreshResults;
        vm.refreshNameResults = refreshNameResults;
        vm.refreshEmailResults = refreshEmailResults;
        vm.refreshPavilionResults = refreshPavilionResults;
        vm.isEmpty = isEmpty;
        vm.selectNameResults = selectNameResults;
        vm.checkIfHasPavilion = checkIfHasPavilion;
        //vm.selectEmailResults = selectEmailResults;
        
        
        async function activate() {
            await vm.getPreRegistrations();
            await vm.getRegisters();
            await vm.checkPreRegisterVsRegister();
            await vm.checkIfHasPavilion();
        }

       async function checkIfHasPavilion () {
        angular.forEach(vm.expos, function(expo, keyExpo) {
            if (expo.exclusive_pavilion && expo.exclusive_pavilion.length) {
                vm.hasPavilion = true;
            }
        });
       }

        function extractFasciaName() {
            return vm.boothNameList = vm.expos.reduce((names, item) => {
                if (typeof item.expos_users.fascia_name !== 'undefined') {
                    if (names && names.indexOf(item.expos_users.fascia_name.trim()) === -1) {
                        names.push(item.expos_users.fascia_name.trim());
                    }
                }
                return names;
            }, []);
        }
        
        function extractPavilionName() {
            var names = [];
            angular.forEach(vm.expos, function(expo, keyExpo) {
                if (expo.exclusive_pavilion && expo.exclusive_pavilion.length) {
                    vm.hasPavilion = true;
                    names = [];

                    expo.exclusive_pavilion.forEach((exclusive_pavilion) => {
                        if (names && names.findIndex(ep => ep.name.trim() == exclusive_pavilion.name.trim())) {
                            names.push({name:exclusive_pavilion.name.trim(), id:exclusive_pavilion.id});
                        }
                    });    

                    expo['pavilionList'] = names;
                }
            });

            // vm.pavilionList = vm.expos.reduce((names, item) => {
            //     if (typeof names == 'undefined') {
            //         names = [];
            //     }
            //     if (item.exclusive_pavilion && item.exclusive_pavilion.length) {
                    
            //         item.exclusive_pavilion.forEach((exclusive_pavilion) => {
            //             if (names && names.findIndex(ep => ep.name.trim() == exclusive_pavilion.name.trim())) {
            //                 names.push({name:exclusive_pavilion.name.trim(), id:exclusive_pavilion.id});
            //             }
            //         });    
            //     }
            //     return names;
            // }, []);
            // vm.pavilionList.unshift({name:"None", id:0});
            // debugger;
            // return vm.pavilionList;
        }

        function extractContactName() {
            return vm.contactNameList = vm.expos.reduce((names, item) => { 
                
                if (typeof item.expos_users.contact_name !== 'undefined') {
                    if (names && names.indexOf(item.expos_users.contact_name.trim()) === -1) {
                        names.push(item.expos_users.contact_name.trim());
                    }
                }
                return names;
            }, []);
        }
        
        function extractContactEmail() {
            return vm.contactEmailList = vm.expos.reduce((names, item) => {
                    if (typeof item.expos_users.contact_email !== 'undefined') {
                        names.push(item.expos_users.contact_email);
                    }
                    return names;
                }, []);
        }

        function isEmpty(obj) {
            for(var key in obj) {
                if(obj.hasOwnProperty(key))
                    return false;
            }
            return true;
        }

        async function checkPreRegisterVsRegister() {
            vm.preRegistrations.map( preRegistration => {
                if (vm.registrations.includes(preRegistration)) {
                    alert('Pre-registration not loaded because the selected user is already enrolled in the fair. This may happen if the user pre-registered more than once in the same fair.\n\nGo back to leave as it is; or\n\nProceed by saving the form to also link this pre-registration to the user.');
                    //return true;
                }
            });
        }

        async function getPreRegistrations() {
            let query = [];
            if ($stateParams.hasOwnProperty('prId')) {
                query['pre_registration_id'] = $stateParams.prId;
                query['user_id'] = $stateParams.userId;
            }
            VirtualFairService.getPreRegistrationsByFair(query)
            .then(function(response) {
                angular.forEach(response.data, function(item, key) {
                    angular.forEach(vm.expos, function(expo, keyExpo) {
                        if (!expo.hasOwnProperty('expos_users')) {
                            expo.expos_users = {};
                        }
                       
                        if (expo.id == item.expos_virtual_fair_id) {
                            
                            if (item.expos_user_virtual_fair_id == null) {
                                vm.preRegistrations.push(expo.id);
                                
                                expo.expos_users = item.expos_users !== null ? 
                                    item.expos_users : {
                                        contact_name: item.representative_name, 
                                        contact_email: item.email,
                                        exclusive_pavilion_name: item.expos_users && typeof item.expos_users.exclusive_pavilion != 'undefinded' && item.expos_users.exclusive_pavilion.length ? {name: item.expos_users.exclusive_pavilion.name, id:item.expos_users.exclusive_pavilion.id } : {name: 'None', id:0},
                                        expo_virtual_fair_pavilion_id: item.expos_users && item.expos_users.exclusive_pavilion != null && item.expos_users.exclusive_pavilion.id || null,
                                        networking_event:false,
                                        ai_agent:false
                                    };
                                if (item.hasOwnProperty('expos_users') && typeof item.expos_users == 'undefined') {
                                    if (item.expos_users == null) {
                                        item.expos_users = {};
                                    }
                                    item.expos_users['networking_event'] = item.expos_users['networking_event'] == '1'? true : false;
                                    item.expos_users['ai_agent'] = item.expos_users['ai_agent'] == '1'? true : false;
                                }
                            } else {
                                expo.expos_users = item.expos_users || {networking_event:false};
                                if (item.hasOwnProperty('expos_users') && typeof item.expos_users !== 'undefined') {
                                    item.expos_users.networking_event = item.expos_users.networking_event == '1'? true : false;;
                                    item.expos_users.ai_agent = item.expos_users.ai_agent == '1'? true : false;
                                }
                            }
                            expo.invoiced = false;
                            expo.show_in_form = true;
                            expo.selected = true;
                            expo.has_networking_event = expo.has_networking_event == 0? false : true;
                            expo.has_ai_agent = expo.ai_agent_rate == 0? false : true;
                            
                        }
                    });
                });
                return vm.expos;
            });   
        }
        
        async function getRegisters() {
            let query = [];
            if ($stateParams.hasOwnProperty('userId')) {
                query['user_id'] = $stateParams.userId;
            }
            
            VirtualFairService.getRegistrationsByUser(query)
            .then(function(response) {
                vm.registeredFairs = response.data;
                vm.expos.map(expo => {
                    angular.forEach(response.data, function(item) {
                        if (!expo.hasOwnProperty('expos_users')) {
                            expo.expos_users = {};
                        }
                        if (expo.id === item.id) {
                            vm.registrations.push(expo.id);
                            expo.expos_users = item.expos_users[0] || {networking_event:false};
                            expo.expos_users = item.expos_users[0] || {ai_agent:false};
                            expo.expos_users.contact_name = item.expos_users[0].contact_name;
                            expo.expos_users.contact_email = item.expos_users[0].contact_email;
                            expo.expos_users.fascia_name = item.expos_users[0].fascia_name;
                            expo.expos_users.exclusive_pavilion_name = item.expos_users[0] && typeof item.expos_users[0].exclusive_pavilion != 'undefinded' && item.expos_users[0].exclusive_pavilion.length ? {name: item.expos_users[0].exclusive_pavilion[0].name, id:item.expos_users[0].exclusive_pavilion[0].id } : {name: 'None', id:0};
                            expo.expos_users.expo_virtual_fair_pavilion_id = item.expos_users[0].expo_virtual_fair_pavilion_id || null;
                            
                            if (item.hasOwnProperty('expos_users') && typeof item.expos_users[0] !== 'undefined') {
                                item.expos_users[0].networking_event = item.expos_users[0].networking_event == 1 ? true : false;
                                item.expos_users[0].ai_agent = item.expos_users[0].ai_agent == 1 ? true : false;
                            }
                            expo.invoiced = item.expos_virtual != [];
                            expo.show_in_form = true;
                            expo.selected = true;
                            expo.has_networking_event = expo.has_networking_event == 0 ? false : true;
                            expo.has_ai_agent = expo.ai_agent_rate == 0? false : true;
                        }
                    });
                    
                });
                vm.checkPreRegisterVsRegister();
                return vm.expos;
            });  
        }

        function seeAllEvents() {
            vm.expos.map(expo => {
                if (!expo.show_in_form)  {
                    expo.has_networking_event = expo.has_networking_event =='0'? 0 : 1;
                    expo.has_ai_agent = expo.ai_agent_rate == 0? 0 : 1;
                    expo.expos_users = {networking_event:false};
                    expo.invoiced = false;
                    expo.show_in_form = true;
                    expo.selected = false;
                }
            });
        }
        
        function clearFields(expo) {
            vm.expos.filter((item) => {
                if(item === expo) {
                    item.contact_name = '';
                    item.contact_email = '';
                }
            });
        }

        function toogle(expo) {
            if (!expo.selected) {
                expo.fascia_name = '';
                vm.clearFields(expo);
            }   
        }

        async function refreshResults($select) {
            let search = $select.search;
            let list = await vm.extractFasciaName();
            
            if (typeof vm.boothNameList !== 'undefined' && vm.boothNameList.length) {
                vm.boothNameList.filter((name, index, names) => name && names.indexOf(name) == index)
            }
            if (search && vm.boothNameList.indexOf(search) === -1) {
                vm.boothNameList.unshift(search);
            } 
            if (!search) {
                $select.items = list;
            } else {
                $select.items = [search].concat(list);            
                $select.selected = search;
            }
        }
        
        async function refreshNameResults($select, expo) {
            let search = $select.search;
            let list = await vm.extractContactName();
            let listTemp = [];
            let item = {};
            
            if (typeof list !== 'undefined' && list.length) {
                listTemp = list
                .map(  el => {
                    return el.name;
                })
                .filter((name, index, names) => name && names.indexOf(name) == index);
            }
            
            if (search && listTemp.indexOf(search) === -1) {
                vm.contactNameList.unshift(search);
            } 
            if (!search) {
                $select.items = list;
            } else {
                $select.items = [search].concat(list);     
                $select.selected = search;
            }
        }

        function selectNameResults($select, expo) {
            let obj = [];
            let obj2 = [];

            obj = vm.expos.filter( item => item.show_in_form == 1);
            if (obj) {
                obj2 = obj.filter( el => el.expos_users.contact_name == expo.expos_users.contact_name && el.id !== expo.id);
                if (typeof obj2[0] == 'undefined') {
                    expo.expos_users.contact_email = '';
                    return;
                }
                expo.expos_users.contact_email = obj2[0].expos_users.contact_email;
            }
        }

        async function refreshEmailResults($select) {
            let search = $select.search;
            let list = await vm.extractContactEmail();
            
            if (typeof vm.contactEmailList !== 'undefined' && vm.contactEmailList.length) {
                vm.contactEmailList.filter((name, index, names) => name && names.indexOf(name) == index)
            }
            if (search && vm.contactEmailList.indexOf(search) === -1) {
                vm.contactEmailList.unshift(search);
            } 
            if (!search) {
                $select.items = list;
            } else {
                $select.items = [search].concat(list);            
                $select.selected = search;
            }
        }
        
        async function refreshPavilionResults($select) {
            let search = $select.search.name;
            let list = await vm.extractPavilionName();
            
            if (typeof vm.pavilionList !== 'undefined' && vm.pavilionList.length) {
                vm.pavilionList.filter((item, index, names) => item.name && names.indexOf(item.name) == index)
            }
            if (search && vm.pavilionList.indexOf(search) === -1) {
                vm.pavilionList.unshift($select.search);
            } 
            if (!search) {
                $select.items = list;
            } else {
                $select.items = [$select.search].concat(list);            
                $select.selected = $select.search;
            }
        }

        async function prepareData() {
            vm.query = {};
            vm.query['createOrUpdate'] = [];
            vm.query['exposIdRegisteredFairs'] = [];
            vm.expos.map( item => {               
                if (item.selected) {
                    if ($stateParams.hasOwnProperty('prId')) {
                        item.pre_registration_id = $stateParams.prId;
                        item.expos_users.user_id = $stateParams.userId;
                    }
                    if(item.hasOwnProperty('expos_users') && item.expos_users.hasOwnProperty('contact_name') && item.expos_users.hasOwnProperty('contact_email') && item.expos_users.hasOwnProperty('fascia_name')) {   
                        item.expos_users.pay = (item.early_bird_datetime_utc > vm.today ? item.early_bird_rate : item.rate);
                        if (item.expos_users.hasOwnProperty('exclusive_pavilion_name')) {
                            item.expos_users.expo_virtual_fair_pavilion_id = item.expos_users.exclusive_pavilion_name.id;
                    
                            if (item.expos_users.exclusive_pavilion_name.name == 'None') {
                                item.expos_users.expo_virtual_fair_pavilion_id = null;
                            }
                        }
                        vm.query['createOrUpdate'].push(item); 
                    } else {
                        toastr.error('Something went wrong. Please try again later');
                        return false;
                    } 
                }
            });
            vm.registeredFairs.forEach( (item) => {
                vm.query['exposIdRegisteredFairs'].push(item.expos_virtual[0].id);
            })
        }

        async function save() {
            await vm.prepareData();
            vm.saving = true;
            VirtualFairService.saveRegister(vm.query)
            .then(function(response) {
               $state.go('root.virtualfair.preApproved', {'error': false,'msg':'Successfully Updated!'});
            }).catch(err => {
                console.log(err);
                $state.go('root.virtualfair.preApproved', {'error': true,'msg': err});
            })
            .finally(() => vm.saving = false);

        }
        activate();

    }
})();
